export function generateUUID() {
  return self.crypto.randomUUID()
}
